// invoiceStatusModal.js - Manages the invoice status update modal.

// Define the mapping from status text to emoji (defined globally for access)
// Ensure this is defined only once across all concatenated files.
// If another file defines it, remove this definition.
if (typeof window.Lux_statusEmojiMap === 'undefined') {
  window.Lux_statusEmojiMap = {
    open: '⚪',
    'feedback needed from administrator': '👤',
    approved: '✅',
  }
}

function checkBalanceConsistency(balances) {
  if (!balances || balances.length <= 1) {
    return true // Empty or single item is considered consistent
  }
  const firstStatus = balances[0].status
  // Treat null, undefined, and empty string as the same for comment consistency
  const normalizeComment = (c) => (c || '').trim()
  const firstComment = normalizeComment(balances[0].comment)

  for (let i = 1; i < balances.length; i++) {
    if (
      balances[i].status !== firstStatus ||
      (normalizeComment(balances[i].comment) !== firstComment &&
        firstStatus !== 'approved')
    ) {
      return false // Found inconsistency
    }
  }
  return true // All items are consistent
}

// Store reference to the controller instance managing the modal's state
let Lux_Modal_currentController = null
// Store listener references attached by the modal to the controller for cleanup
let Lux_Modal_controllerListeners = {}

/**
 * Creates the modal structure in the DOM if it doesn't exist.
 * Should be called once, typically when the page script initializes.
 */
function Lux_Modal_createStatusModal(mode, user) {
  const modalId = 'luxPostingItemStatusModal'
  if (document.getElementById(modalId)) return // Already created

  console.log('Creating Posting Item Status Modal...')

  // Define button IDs for easier reference
  const closeBtnId = `${modalId}-closeButton`
  const acceptBtnId = `${modalId}-acceptButton`
  const commentBtnId = `${modalId}-commentButton`
  const cancelBtnId = `${modalId}-cancelButton`
  const saveBtnId = `${modalId}-saveButton`
  const acceptAllBtnId = `${modalId}-acceptAllBtnId`
  const commentAllBtnId = `${modalId}-commentAllBtnId`
  const relatedBalancesId = `${modalId}-relatedBalancesId`

  const modalHTML = `
    <div id="${modalId}" style="display: none; position: fixed; z-index: 2000; left: 0; top: 0; width: 100%; height: 100%; overflow: auto; background-color: rgba(0,0,0,0.4);" data-mode="${mode}" data-user="${user}">
      <div style="background-color: #fefefe; margin: 15% auto; padding: 20px; border: 1px solid #888; width: 80%; max-width: 500px; border-radius: 5px; position: relative;">
        <span id="${closeBtnId}" style="color: #aaa; position: absolute; top: 10px; right: 15px; font-size: 28px; font-weight: bold; cursor: pointer; line-height: 1;">&times;</span>
        <h2 id="${modalId}-title" style="margin-top: 0;">Update Status</h2>
        <p id="${modalId}-loading" style="display: none; text-align: center; margin: 15px 0;">Lädt...</p>
        <p id="${modalId}-error" style="display: none; color: red; text-align: center; margin: 15px 0;"></p>

        <!-- Initial Choice Section -->
        <div id="${modalId}-initialChoice" style="margin-bottom: 15px; text-align: center;">
           <div id="${relatedBalancesId}" style="margin-top: 10px;">
            Hier steht was
           </div>
           <button id="${acceptAllBtnId}" style="padding: 10px 15px; margin: 5px; cursor: pointer; background-color: #4A0F50; color: white; border: none; border-radius: 3px;">Dauerauftrag: Akzeptieren</button>
           <button id="${commentAllBtnId}" style="padding: 10px 15px; margin: 5px; cursor: pointer; background-color: #316C72; color: white; border: none; border-radius: 3px;">Dauerauftrag: Kommentar Hinzufügen/Bearbeiten</button>
           <button id="${acceptBtnId}" style="padding: 10px 15px; margin: 5px; cursor: pointer; background-color: #4CAF50; color: white; border: none; border-radius: 3px;">Buchung: Akzeptieren</button>
           <button id="${commentBtnId}" style="padding: 10px 15px; margin: 5px; cursor: pointer; background-color: #ff9800; color: white; border: none; border-radius: 3px;">Buchung: Kommentar Hinzufügen/Bearbeiten</button>
        </div>

        <!-- Comment Section (Initially Hidden) -->
        <div id="${modalId}-commentSection" style="display: none;">
          <p id="${modalId}-warning" style="color: orange; display: none; margin-top: 0; margin-bottom: 10px; font-weight: bold;"></p>
          <label for="${modalId}-commentBody" style="display: block; margin-bottom: 5px; font-weight: bold;">Comment:</label>
          <textarea id="${modalId}-commentBody" rows="4" style="width: 100%; padding: 8px; margin-bottom: 15px; border: 1px solid #ccc; border-radius: 4px; box-sizing: border-box; resize: vertical;"></textarea>
          <div style="text-align: right; margin-top: 10px;">
            <button id="${cancelBtnId}" style="padding: 10px 15px; margin-right: 10px; cursor: pointer; background-color: #f44336; color: white; border: none; border-radius: 3px;">Cancel</button>
            <button id="${saveBtnId}" style="padding: 10px 15px; cursor: pointer; background-color: #4CAF50; color: white; border: none; border-radius: 3px;">Save Comment</button>
          </div>
        </div>

        <!-- Overwrite Confirmation Section (Initially Hidden) -->
        <div id="${modalId}-overwriteConfirm" style="display: none; margin-top: 15px; border-top: 1px solid #eee; padding-top: 15px;">
          <p style="margin-top: 0; margin-bottom: 10px; font-weight: bold; color: red;">Warning!</p>
          <p id="${modalId}-overwriteMessage" style="margin-bottom: 15px;">This will overwrite different comments on other balances. Proceed?</p>
          <div style="text-align: center;">
            <button id="${modalId}-overwriteConfirmBtn" style="padding: 10px 15px; margin: 5px; cursor: pointer; background-color: #f44336; color: white; border: none; border-radius: 3px;">Overwrite</button>
            <button id="${modalId}-overwriteCancelBtn" style="padding: 10px 15px; margin: 5px; cursor: pointer; background-color: #757575; color: white; border: none; border-radius: 3px;">Cancel</button>
          </div>
        </div>

      </div>
    </div>
  `
  document.body.insertAdjacentHTML('beforeend', modalHTML)

  // --- Attach Event Listeners using Delegation on the Modal ---
  const modalElement = document.getElementById(modalId)

  modalElement.addEventListener('click', (event) => {
    const target = event.target
    const button = target.closest('button') // Find closest button if clicked inside

    // Close button or clicking outside content
    if (target.id === closeBtnId || target === modalElement) {
      Lux_Modal_hideStatusModal()
      return
    }

    if (!button) return // Ignore clicks not on buttons

    // Handle button clicks based on ID
    const saveButton = document.getElementById(`${modalId}-saveButton`)
    switch (button.id) {
      case acceptBtnId:
        Lux_Modal_handleAccept()
        break
      case commentBtnId:
        saveButton.dataset.mode = 'single order'
        Lux_Modal_handleShowCommentSection()
        break
      case cancelBtnId:
        Lux_Modal_hideStatusModal()
        break
      case saveBtnId:
        Lux_Modal_handleModalSave()
        break
      case acceptAllBtnId:
        Lux_Modal_handleAcceptAll()
        break
      case commentAllBtnId:
        saveButton.dataset.mode = 'standing order'
        Lux_Modal_handleShowCommentSection()
        break
    }
  })
  console.log('Delegated click listener added to modal.')
}

/**
 * Shows the status modal, subscribes to controller events, and populates based on state.
 * @param {AccountBalanceStatusController} controllerInstance - The controller managing this item.
 */
function Lux_Modal_showStatusModal(
  controllerInstance,
  mode = 'single order',
  user = 'advisory council'
) {
  if (
    !controllerInstance ||
    !(controllerInstance instanceof AccountBalanceStatusController)
  ) {
    console.error(
      'Invalid controller instance passed to Lux_Modal_showStatusModal'
    )
    alert('Error: Cannot open status editor (invalid controller).')
    return
  }

  // Ensure modal structure exists (call if needed, it's idempotent)
  Lux_Modal_createStatusModal(mode, user)

  const modalId = 'luxPostingItemStatusModal'
  const modal = document.getElementById(modalId)
  const initialChoiceDiv = document.getElementById(`${modalId}-initialChoice`)
  const commentSectionDiv = document.getElementById(`${modalId}-commentSection`)
  const acceptButton = document.getElementById(`${modalId}-acceptButton`)
  const commentButton = document.getElementById(`${modalId}-commentButton`)
  const modalTitle = document.getElementById(`${modalId}-title`)
  const warningP = document.getElementById(`${modalId}-warning`)
  const commentTextarea = document.getElementById(`${modalId}-commentBody`)
  const saveButton = document.getElementById(`${modalId}-saveButton`)
  const acceptAllBtn = document.getElementById(`${modalId}-acceptAllBtnId`)
  const commentAllBtn = document.getElementById(`${modalId}-commentAllBtnId`)
  const loadingP = document.getElementById(`${modalId}-loading`)
  const errorP = document.getElementById(`${modalId}-error`)

  if (
    !modal ||
    !initialChoiceDiv ||
    !commentSectionDiv ||
    !acceptButton ||
    !commentButton ||
    !modalTitle ||
    !warningP ||
    !commentTextarea ||
    !saveButton ||
    !loadingP ||
    !errorP
  ) {
    console.error('Modal element or one of its children not found!')
    return
  }

  // --- Store controller and Clean Up Previous Listeners ---
  // Unsubscribe any listeners attached to a *previous* controller instance
  Lux_Modal_unsubscribeFromController()
  Lux_Modal_currentController = controllerInstance
  Lux_Modal_controllerListeners = {} // Reset listeners object for the new controller

  // Reset UI to initial/loading state
  modalTitle.textContent = `Buchung Bearbeiten`
  initialChoiceDiv.style.display = 'none' // Hide choices until data loads
  commentSectionDiv.style.display = 'none'
  warningP.style.display = 'none'
  errorP.style.display = 'none'
  acceptAllBtn.style.display = 'none'
  commentAllBtn.style.display = 'none'
  loadingP.style.display = 'block' // Show loading initially
  commentTextarea.value = ''
  commentTextarea.disabled = false
  saveButton.disabled = false
  saveButton.textContent = 'Kommentar Speichern'
  acceptButton.disabled = false
  acceptButton.textContent = 'Buchung Bestätigen'
  if (mode === 'standing order') {
    acceptButton.style.display = 'none'
    commentButton.style.display = 'none'
  } else if (user === 'administrator') {
    acceptButton.style.display = 'inline'
    commentButton.style.display = 'none'
  } else {
    acceptButton.style.display = 'inline'
    commentButton.style.display = 'inline'
  }

  commentButton.disabled = false

  // Update UI based on current controller data (if available)
  const currentData = Lux_Modal_currentController.getCurrentData()
  if (currentData) {
    Lux_Modal_updateUI(currentData)
  }

  // --- Subscribe Modal UI functions to Controller Events ---
  const subscribe = (eventName, handler) => {
    const listener = handler.bind(this) // Ensure correct 'this' if needed, though likely not here
    Lux_Modal_controllerListeners[eventName] = listener
    Lux_Modal_currentController.on(eventName, listener)
  }

  subscribe('update', (data) => Lux_Modal_updateUI(data))
  modal.style.display = 'block'
}

/**
 * Updates the modal's internal UI based on data.
 * This can be called initially or by controller event listeners.
 * @param {object} data - The data object {status, comment, ...}
 */
function Lux_Modal_updateUI(data) {
  // --- Date Formatting Helper ---
  function formatDate(dateString) {
    if (!dateString) return 'N/A'
    try {
      // Basic YYYY-MM-DD to locale date string
      const [year, month, day] = dateString.split('-')
      const date = new Date(year, month - 1, day) // Month is 0-indexed
      return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })
    } catch (e) {
      console.error('Error formatting date:', dateString, e)
      return dateString // Return original if formatting fails
    }
  }

  const modalId = 'luxPostingItemStatusModal'
  const modal = document.getElementById(modalId)
  const initialChoiceDiv = document.getElementById(`${modalId}-initialChoice`)
  const commentSectionDiv = document.getElementById(`${modalId}-commentSection`)
  const acceptButton = document.getElementById(`${modalId}-acceptButton`)
  const commentButton = document.getElementById(`${modalId}-commentButton`)
  const warningP = document.getElementById(`${modalId}-warning`)
  const commentTextarea = document.getElementById(`${modalId}-commentBody`)
  const saveButton = document.getElementById(`${modalId}-saveButton`)
  const loadingP = document.getElementById(`${modalId}-loading`)
  const errorP = document.getElementById(`${modalId}-error`)
  const modalTitle = document.getElementById(`${modalId}-title`)
  const acceptAllBtn = document.getElementById(`${modalId}-acceptAllBtnId`)
  const commentAllBtn = document.getElementById(`${modalId}-commentAllBtnId`)

  if (!data || !initialChoiceDiv) return // Exit if elements not found or no data

  let sectionsHTML = ''
  const isConsistent = checkBalanceConsistency(data.relatedOrders)
  if (data.relatedOrders?.length > 1) {
    sectionsHTML = `
  Diese Buchung ist Teil eines Dauerauftrages.
  Die folgende Tabelle zeigt eine Übersicht über alle zugehörigen Buchungen in diesem Jahr.
  ${isConsistent ? 'Aktuell befinden sich alle Buchungen im gleichen Status' : 'Die Stati der Buchungen untescheiden sich aktuell. Sie können die Knöpfe für den Dauerauftrag benutzen um den Status für alle Buchungen zu setzen.'}
  <table>
  <tr>
    <th>Datum</th>
    <th>Status</th>
    <th>Kommentar</th>
  </tr>
  `
    data.relatedOrders.forEach((balance) => {
      const statusEmoji = window.Lux_statusEmojiMap?.[balance.status] || '❓'
      const commentDisplayHtml = balance.comment
        ? balance.comment.replace(/\n/g, '<br>')
        : '<em>No comment.</em>'
      const canApprove = balance.status !== 'approved'
      const formattedDate = formatDate(balance.postingDate)

      // Unique ID for the approve status span for this specific item
      const approveStatusSpanId = `lux-approve-status-${balance.postingItemId}`

      const representativePostingItemId = balance.postingItemId
      const commentSection =
        balance.status === 'feedback needed from administrator'
          ? `<div
          class="ant-col ant-col-24"
          style="padding-left: 12px; padding-right: 12px"
        >
          <div class="TextInput">
            <div
              class="ant-row ant-form-item ant-form-item-with-help"
              style="row-gap: 0px"
            >
              <div class="ant-col ant-form-item-label">
                <label class="" title=""
                  ><span><span>Kommentar: </span></span></label
                >
              </div>
            </div>
          </div>
        </div>

        <div class="ant-col ant-form-item-control">
      <div class="ant-form-item-control-input">
        <div class="ant-form-item-control-input-content">
          <div
            class="ant-select ant-select-in-form-item Select read-only ant-select-single ant-select-allow-clear ant-select-show-arrow ant-select-disabled ant-select-show-search"
          >
            <div class="ant-select-selector" style="height: auto;">
              <span class="ant-select-selection-item"  title="${commentDisplayHtml}">
              ${commentDisplayHtml}
              </span>
            </div>
          </div>
        </div>
      </div>`
          : ''
      sectionsHTML += `
      <tr>
    <td>${formattedDate}</td>
    <td>${statusEmoji}</td>
    <td>${commentDisplayHtml}</td>
  </tr>
`
    })
    sectionsHTML += '</table>'
  }
  const relatedBalances = document.getElementById(
    `${modalId}-relatedBalancesId`
  )
  relatedBalances.innerHTML = sectionsHTML
  modalTitle.textContent = data.isStandingOrder
    ? 'Dauerauftrag Bearbeiten'
    : 'Buchung Bearbeiten'

  loadingP.style.display = 'none' // Hide loading indicator
  errorP.style.display = 'none' // Hide error message

  // Show the main content sections (initial choice or comment section)
  // Reset to initial choice view by default, unless comment section was active
  if (commentSectionDiv.style.display !== 'block') {
    initialChoiceDiv.style.display = 'block'
  }
  const user = modal.dataset?.user

  const currentStatus = data.status
  const currentComment = data.comment
  acceptAllBtn.style.display = data.isStandingOrder ? 'inline' : 'none'
  commentAllBtn.style.display =
    data.isStandingOrder && user === 'advisory council' ? 'inline' : 'none'

  // Set comment button text
  commentButton.textContent =
    currentComment && currentComment.trim() !== ''
      ? 'Buchung: Kommentar Bearbeiten'
      : 'Buchung: Kommentar Hinzufügen'

  // Set textarea value (useful if editing)
  commentTextarea.value = currentComment || ''

  // Disable Accept button if already approved
  acceptButton.disabled = currentStatus === 'approved'
  acceptButton.textContent =
    currentStatus === 'approved' ? 'Bereits Bestätigt' : 'Buchung Bestätigen'

  // Reset save button state
  saveButton.disabled = false
  saveButton.textContent = 'Save Comment'

  // Show warning if needed (only relevant if comment section is visible)
  if (commentSectionDiv.style.display === 'block') {
    warningP.style.display = currentStatus === 'approved' ? 'block' : 'none'
    warningP.textContent =
      'Achtung: Diese Buchung wurde bereits bestätigt. Die Bearbeitung des Kommentars nimmt diese Bestätigung zurück.'
  } else {
    warningP.style.display = 'none'
  }
}

/**
 * Handles showing error messages within the modal.
 * @param {Error | string} error - The error object or message.
 */
function Lux_Modal_showError(error) {
  const modalId = 'luxPostingItemStatusModal'
  const errorP = document.getElementById(`${modalId}-error`)
  const loadingP = document.getElementById(`${modalId}-loading`)
  const initialChoiceDiv = document.getElementById(`${modalId}-initialChoice`)
  const commentSectionDiv = document.getElementById(`${modalId}-commentSection`)

  if (!errorP || !loadingP || !initialChoiceDiv || !commentSectionDiv) return

  loadingP.style.display = 'none'
  initialChoiceDiv.style.display = 'none'
  commentSectionDiv.style.display = 'none'
  errorP.textContent = `Error: ${error?.message || error}`
  errorP.style.display = 'block'

  // Optionally re-enable buttons if appropriate after an error
  // (e.g., save/accept buttons if the action failed)
  // This might be better handled by specific error event listeners defined by the caller.
}

async function Lux_Modal_handleAcceptAll() {
  console.log('Approve All clicked')
  if (!Lux_Modal_currentController) {
    console.error('Accept clicked but controller is missing.')
    alert('Error: Controller not found.')
    return
  }
  const acceptButton = document.getElementById(
    'luxPostingItemStatusModal-acceptButton'
  )
  if (acceptButton) {
    acceptButton.disabled = true
    acceptButton.textContent = 'Dauerauftrag wird akzeptiert'
  }
  // Controller will handle API call and emit events
  Lux_Modal_currentController.approveBalance('standing order')
}

/**
 * Handles the click on the "Accept Balance" button. Delegates to the controller.
 */
function Lux_Modal_handleAccept() {
  if (!Lux_Modal_currentController) {
    console.error('Accept clicked but controller is missing.')
    alert('Error: Controller not found.')
    return
  }
  const acceptButton = document.getElementById(
    'luxPostingItemStatusModal-acceptButton'
  )
  if (acceptButton) {
    acceptButton.disabled = true
    acceptButton.textContent = 'Accepting...'
  }
  // Controller will handle API call and emit events
  Lux_Modal_currentController.approveBalance('single order')
}

/**
 * Handles the click on the "Add/Edit Comment" button. Shows the comment section.
 */
function Lux_Modal_handleShowCommentSection() {
  const modalId = 'luxPostingItemStatusModal'
  const initialChoiceDiv = document.getElementById(`${modalId}-initialChoice`)
  const commentSectionDiv = document.getElementById(`${modalId}-commentSection`)
  const modalTitle = document.getElementById(`${modalId}-title`)
  const warningP = document.getElementById(`${modalId}-warning`)
  const commentTextarea = document.getElementById(`${modalId}-commentBody`)

  if (
    !Lux_Modal_currentController ||
    !initialChoiceDiv ||
    !commentSectionDiv ||
    !modalTitle ||
    !warningP ||
    !commentTextarea
  ) {
    console.error(
      'Cannot show comment section, elements or controller missing.'
    )
    return
  }

  const currentData = Lux_Modal_currentController.getCurrentData()
  const currentComment = currentData?.comment
  const currentStatus = currentData?.status

  // Hide initial choices, show comment section
  initialChoiceDiv.style.display = 'none'
  commentSectionDiv.style.display = 'block'

  // Set title and pre-fill comment
  modalTitle.textContent =
    currentComment && currentComment.trim() !== ''
      ? 'Edit Comment'
      : 'Add Comment'
  commentTextarea.value = currentComment || ''

  // Show warning if status is currently 'approved'
  warningP.style.display = currentStatus === 'approved' ? 'block' : 'none'
  warningP.textContent =
    'Achtung: Diese Buchung wurde bereits bestätigt. Die Bearbeitung des Kommentars nimmt diese Bestätigung zurück.'
}

/**
 * Hides the status modal and resets the controller reference.
 */
function Lux_Modal_hideStatusModal() {
  const modalId = 'luxPostingItemStatusModal'
  const modal = document.getElementById(modalId)
  if (modal) {
    modal.style.display = 'none'
    // Also hide the new sections explicitly
    const overwriteConfirmDiv = document.getElementById(
      `${modalId}-overwriteConfirm`
    )
    if (overwriteConfirmDiv) overwriteConfirmDiv.style.display = 'none'
  }
  // Clean up controller reference and unsubscribe listeners
  Lux_Modal_unsubscribeFromController()
  Lux_Modal_currentController = null
}

/** Helper function to unsubscribe modal listeners from the current controller */
function Lux_Modal_unsubscribeFromController() {
  if (
    Lux_Modal_currentController &&
    Object.keys(Lux_Modal_controllerListeners).length > 0
  ) {
    console.log(
      `Modal: Unsubscribing ${Object.keys(Lux_Modal_controllerListeners).length} listeners from controller ID ${Lux_Modal_currentController.id}`
    )
    Object.keys(Lux_Modal_controllerListeners).forEach((event) => {
      Lux_Modal_currentController.off(
        event,
        Lux_Modal_controllerListeners[event]
      )
    })
  }
  Lux_Modal_controllerListeners = {} // Clear the stored listeners
}

/**
 * Handles the save action. Delegates to the controller.
 */
function Lux_Modal_handleModalSave() {
  if (!Lux_Modal_currentController) {
    console.error('Save clicked but controller is missing.')
    alert('Error: Controller not found.')
    return
  }

  const comment = document.getElementById(
    'luxPostingItemStatusModal-commentBody'
  )?.value
  const saveButton = document.getElementById(
    'luxPostingItemStatusModal-saveButton'
  )
  const cancelButton = document.getElementById(
    'luxPostingItemStatusModal-cancelButton'
  ) // Get cancel button too

  if (saveButton) {
    saveButton.disabled = true
    saveButton.textContent = 'Saving...'
  }
  if (cancelButton) {
    cancelButton.disabled = true // Disable cancel during save
  }

  console.log({ saveButtonMode: saveButton?.dataset?.mode })
  // Controller handles API call and emits events
  Lux_Modal_currentController.saveComment(comment, saveButton?.dataset?.mode)

  // Re-enable buttons on error is now handled by the 'saveError' listener subscribed above
  // The success case (closing modal) might need adjustment depending on external listeners.
}
